import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Popup from "../../../components/customHelpers/Popup";
import ChangeCustomer from "../../../components/forms/customers";
import Notification from "../../../components/customHelpers/Notification";
import Notify from "../../../components/customHelpers/Notify";

const PropertyRow = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 0.5,
      flexWrap: "wrap",
    }}
  >
    <Typography sx={{ fontWeight: 500, color: "text.secondary", fontSize: "0.875rem", minWidth: 35 }}>
      {label}:
    </Typography>
    <Typography sx={{ fontWeight: 500, color: "text.primary", fontSize: "0.875rem" }}>
      {value ?? "N/A"}
    </Typography>
  </Box>
);

const CustomerDetails = ({ product, title, getOrderData, change, id }) => {
  const [openPopupChange, setOpenPopupChange] = useState(false);
  const { NotifyMessage, notify, setNotify } = Notify();

  if (!product.customer) return null;

  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "grey.200",
        borderRadius: 1,
        boxShadow: 1,
        p: 2,
        gap: 1,
        height: "100%",
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 600,
          color: "#1F2937",
          fontSize: "0.875rem",
          mb: 0.5,
          borderBottom: 1,
          borderColor: "grey.200",
          pb: 0.5,
        }}
      >
        {title ?? "Bill To"}
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mb: 1 }}>
        <PropertyRow label="Name" value={product.customer.fullName} />
        <PropertyRow label="Email" value={product.customer.email} />
        <PropertyRow label="Phone" value={product.customer.phoneNo} />
        <PropertyRow label="Location" value={product.customer.location} />
        <PropertyRow label="Address" value={product.customer.address} />
        <PropertyRow label="Contact" value={product.customer.contact} />
      </Box>

      {change && (
        <Button
          variant="contained"
          startIcon={<EditIcon />}
          onClick={() => setOpenPopupChange(true)}
          sx={{
            mt: 1,
            textTransform: "capitalize",
            fontSize: "0.75rem",
            px: 1,
            py: 0.5,
            height: 32,
            minHeight: 26,
            width: 180,
            backgroundColor: "rgba(244,151,3,0.8)",
            color: "rgb(20,61,89)",
            "&:hover": { backgroundColor: "rgba(244,151,3,0.9)" },
            "@media (max-width:1320px)": {
              mt: 0.5,
              fontSize: "0.85rem",
              px: 0.5,
              py: 0.5,
              width: 200,
            },
          }}
        >
          Change Customer
        </Button>
      )}

      <Popup
        title="Change Customer"
        openPopup={openPopupChange}
        setOpenPopup={setOpenPopupChange}
      >
        <ChangeCustomer
          NotifyMessage={NotifyMessage}
          id={id}
          setOpenPopupBulkSave={setOpenPopupChange}
          getOrderData={getOrderData}
          setOpenPopup={setOpenPopupChange}
        />
      </Popup>

      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
};

export default CustomerDetails;
